import { TriangleAlert } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";

interface ExchangeLocationFormErrorProps {
  message?: string;
}

export const ExchangeLocationFormError = ({ message }: ExchangeLocationFormErrorProps) => {
  if (!message) {
    return null;
  }

  return (
    <Alert variant="destructive">
      <TriangleAlert className="size-4" />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
};
